<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="청약안내" tabActive="금융지원" bg="/images/sub/subscription/visual.jpg">
                <template #title>청약안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>금융지원</template>

            <v-row class="row--xl">
                <v-col cols="12" xl="6">
                    <div class="image-wrap">
                        <v-img src="/images/sub/subscription/support/support.jpg" class="support-image">
                            <div class="pa-20 pa-md-42px h-100 d-flex justify-center align-center">
                                <tit class="font-size-lg-36 text-center white--text">
                                    신혼부부와 청년의 SPECIAL 특권! <br />
                                    <span class="font-weight-meidum">무이자 1%대 대출지원</span>
                                </tit>
                            </div>
                        </v-img>
                    </div>
                </v-col>
                <v-col cols="12" xl="6">
                    <template v-for="(item, index) in items">
                        <v-sheet :key="index" height="25%" min-height="120" class="support-sheet">
                            <v-row no-gutters align="center" class="h-100">
                                <v-col>
                                    <tit class="tit--sm font-weight-medium">
                                        {{ item.name }}
                                    </tit>
                                </v-col>
                                <v-col cols="3">
                                    <v-row class="row--xxs">
                                        <template v-for="(button, index) in item.btns">
                                            <v-col :key="index" cols="12">
                                                <v-btn :href="button.link" target="_blank" block tile outlined color="grey lighten-3">
                                                    <span class="grey--text">
                                                        {{ button.name }}
                                                    </span>
                                                </v-btn>
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-sheet>
                    </template>
                </v-col>
            </v-row>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import btnPrimary from "@/components/publish/parents/buttons/btn-primary.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        btnPrimary,
        Tit,
    },
    data: () => ({
        items: [
            {
                name: "청년안심주거비지원",
                btns: [
                    {
                        name: "상세내용 보기",
                        link: "https://housing.seoul.go.kr/site/main/content/sh01_060508",
                    },
                ],
            },
            {
                name: "서울시 임차인 보증금 이자지원 사업",
                btns: [
                    {
                        name: "청년",
                        link: "https://housing.seoul.go.kr/site/main/content/sh01_0400800#non",
                    },
                    {
                        name: "신혼부부",
                        link: "https://housing.seoul.go.kr/site/main/content/sh01_0400800",
                    },
                ],
            },
            {
                name: "중소기업취업청년 전월세보증금대출",
                btns: [
                    {
                        name: "상세내용 보기",
                        link: "https://nhuf.molit.go.kr/FP/FP05/FP0502/FP05020601.jsp",
                    },
                ],
            },
            {
                name: "버팀목 전세자금 대출",
                btns: [
                    {
                        name: "청년",
                        link: "https://nhuf.molit.go.kr/FP/FP05/FP0502/FP05020301.jsp",
                    },
                    {
                        name: "신혼부부",
                        link: "https://nhuf.molit.go.kr/FP/FP05/FP0502/FP05020401.jsp",
                    },
                ],
            },
        ],
    }),
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.support-image {
    aspect-ratio: 2/1;
}
.support-sheet {
    border-top: 1px solid #ececec;
    &:last-child {
        border-bottom: 1px solid #ececec;
    }
}
@media (min-width: 1200px) {
    .support-image {
        aspect-ratio: 1/1;
    }
}
</style>
